module.exports = __webpack_public_path__ + "img/szgxq2.0c096dd6.jpg";